<template>
  <b-container
    class="network-report-filters__body"
    fluid
  >
    <network-filter
      class="mb-4"
      ref="filter"
      :is-valid.sync="isFilterValid"
      :is-period-valid.sync="isPeriodValid"
      @on-download-excel="onDownloadExcelHandler"
      @on-view-report="onViewReportHandler"
    />
    <div class="network-report-filters__button-row button-row">
      <b-button
        class="button-row__excel mb-3 mb-sm-0"
        variant="outline-green"
        :disabled="!isPeriodValid"
        @click="$refs.filter.validateAndEmitFilter('on-download-excel')"
      >
        <s-loader
          v-if="loading"
          class="network-report__xls-loading mr-1"
        />
        <i
          v-else
          class="fas fa-file-excel mx-1"
          aria-hidden="true"
        />
        <span>{{ $t('general.export-xlsx') }}</span>
      </b-button>
      <b-button
        variant="primary"
        :disabled="!isPeriodValid"
        @click="$refs.filter.validateAndEmitFilter('on-view-report')"
      >
        {{ $t('reports.filters.view-report') }}
      </b-button>
    </div>
  </b-container>
</template>

<script>
import globalEventBus from '@/services/globalEventBus';
import loadingMixin from '@/services/loadingMixin';
import networkStatusService from '@/domain/services/generalPanel/networkStatus';
import sessionStorageManager from '@/services/sessionStorageManager';
import NetworkFilter from '@/domain/components/generalPanel/networkStatus/NetworkFilter';
import networkStatusEvents from '@/domain/events/networkStatus';

export default {
  name: 'NetworkStatusReport',
  components: {
    NetworkFilter,
  },
  mixins: [
    loadingMixin,
  ],
  data: () => ({
    filter: {},
    filterObject: {},
    isFilterValid: true,
    isPeriodValid: true,
  }),
  computed: {
    disableExport() {
      return !this.isPeriodValid || this.loading;
    },
  },
  methods: {
    initializeFilters() {
      const { filter: filterId } = this.$route.query;
      if (!filterId) {
        return;
      }

      this.filterObject = sessionStorageManager.getJsonObject(filterId);
      globalEventBus.emit(networkStatusEvents.refreshFilter, this.filterObject);
    },
    onDownloadExcelHandler({ filter }) {
      this.filter = filter;
      this.exportXlsx();
    },
    onViewReportHandler({ filter }) {
      this.filter = filter;
      this.viewReport();
    },
    viewReport() {
      const storageKey = this.setSessionStorage();
      this.goToRoute(storageKey);
    },
    setSessionStorage() {
      const stringifyFilter = JSON.stringify(this.filter);
      return sessionStorageManager.setItemWithId('networkHistoryFilter', stringifyFilter);
    },
    goToRoute(key) {
      const routeData = this.$router.resolve({
        name: 'clean-view.network-status-report.view-report',
        query: {
          filter: key,
        },
      });
      window.open(routeData.href, '_blank');
    },
    exportXlsx() {
      if (!this.isFilterValid) {
        return Promise.reject();
      }

      this.startLoading();

      return networkStatusService.downloadList('xlsx', { filter: this.filter })
        .then(() => {
          this.$pushAlert({ code: 'MS011' });
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$pushAlert({ code: 'MA009' });
          }
        })
        .finally(() => {
          this.endLoading();
        });
    },
  },
  mounted() {
    this.initializeFilters();
  },
};
</script>
<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.network-report-filters
  &__field-label
    font-weight: 600

  &__search-buttons-panel
    text-align: right

  &__button-row
    display: flex
    justify-content: flex-end

    .btn
      justify-content: center

    +media-max-xs()
      flex-direction: column

    button
      display: inline-flex
      align-items: center
      margin-right: .5rem

</style>
